import { Column, Row, Text } from "@bridgesplit/ui";
import { TokenInputWithPrice, BalanceDisplay } from "app/components/common";
import { formatDurationWithTypeShorthand } from "@bridgesplit/abf-sdk";
import { ActionsSettingsButton } from "app/components/loan/actions/common";
import { useStrategyDurations } from "@bridgesplit/abf-react";
import { AppDialog, useAppDialog } from "app/utils";
import { useSetLoopWindDuration } from "app/components/market-detail/borrow/util";
import { History } from "@mui/icons-material";

import { useWindContext } from "../WindContext";
import { useLoopContext } from "../../LoopContext";

export default function ManualWindPrincipal() {
    const { form, setForm, maxBorrowQuote } = useWindContext();
    const { loopExpanded } = useLoopContext();
    const { strategyDurations } = useStrategyDurations();

    const { strategyDuration } = form;
    const { open } = useAppDialog();

    const principalToken = loopExpanded?.principalToken;
    const { setLoopWindDuration } = useSetLoopWindDuration();

    if (!principalToken) {
        return null;
    }

    const maxBorrow = maxBorrowQuote?.maxBorrow;

    const handlePrincipalChange = (principalAmount: number | undefined) => {
        setForm((prev) => ({
            ...prev,
            principalAmount
        }));
    };

    const handleSetMax = () => {
        if (maxBorrow === undefined) return;
        setForm((prev) => ({ ...prev, principalAmount: maxBorrow }));
    };

    return (
        <Column spacing={0.5}>
            <Row spaceBetween>
                <Text variant="body2" color="caption">
                    Borrow
                </Text>
                <ActionsSettingsButton
                    icon={<History fontSize="inherit" sx={{ color: "secondary.main" }} />}
                    rowEndText={`${formatDurationWithTypeShorthand(
                        strategyDuration.duration,
                        strategyDuration.durationType
                    )}`}
                    onClick={() => {
                        open(AppDialog.WindSetTerm, {
                            strategyDurations,
                            strategyDuration,
                            setStrategyDuration: setLoopWindDuration
                        });
                    }}
                />
            </Row>
            <TokenInputWithPrice
                metadata={principalToken}
                selectToken={null}
                value={form.principalAmount}
                setValue={handlePrincipalChange}
                belowInput={
                    <BalanceDisplay
                        isLoading={maxBorrowQuote === undefined}
                        balance={maxBorrow ?? 0}
                        metadata={principalToken}
                        setMax={handleSetMax}
                        insufficientBalance={false}
                        maxText="Max"
                    />
                }
            />
        </Column>
    );
}
